export default "__VITE_ASSET__GrTon23k__"